import { assessmentSerializer } from '@/providers/serializers/content/assessment';
import { collectionSerializer } from '@/providers/serializers/content/collection';
import { contentSerializer } from '@/providers/serializers/content/content';
import { courseSerializer } from '@/providers/serializers/content/course';
import { lessonSerializer } from '@/providers/serializers/content/lesson';
import { questionSerializer } from '@/providers/serializers/content/question';
import { resourceSerializer } from '@/providers/serializers/content/resource';
import { http } from '../http';

/**
 * Content API consist of collection and assessment APIs
 */
export class ContentAPI {

    private static INSTANCE = new ContentAPI();

    private namespace: string = 'api/nucleus/v1';

    private namespaceOa = 'api/nucleus/v2/oa';

    private stubNamespace = 'stubs';

    private resourceNamespace = 'api/missioncontrol/v1/resource';

    static get instance() {
        return this.INSTANCE;
    }

    public fetchAssessment(id: string): Promise<any> {
        const endpoint = `${this.namespace}/assessments/${id}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return assessmentSerializer.normalizeReadAssessment(response.data);
        });
    }


    public fetchCollection(id: string): Promise<any> {
        const endpoint = `${this.namespace}/collections/${id}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return collectionSerializer.normalizeReadCollection(response.data);
        });
    }

    public fetchTranscript(resourceId: string) {
        const endpoint = `${this.resourceNamespace}/transcripts?resource_id=${resourceId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return contentSerializer.normalizeTranscript(response.data);
        });
    }

    /**
     * @return {Promise} fetch transcript for resources
     */

    public fetchSummary(resourceId: string) {
        const endpoint = `${this.resourceNamespace}/summary?resource_id=${resourceId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return contentSerializer.normalizeSummary(response.data);
        });
    }

    /**
     * Reads a grade list
     *
     * @returns {Promise}
     */
    public getGradeList() {
        const endpoint = `${window.location.origin}/${this.stubNamespace}/user-profile-grades.json`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    /**
     * Reads a getMetadataLevel
     *
     * @returns {Promise}
     */
    public getMetadataLevel() {
        const url = `${window.location.origin}/${this.stubNamespace}/meta-data.json`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return response.data;
        });
    }

    /**
     * Reads a resource by id
     *
     * @param {string} resourceId
     * @returns {Promise}
     */
    public getQuestionById(questionId: any) {
        const question = 'questions';
        const url = `${this.namespace}/${question}/${questionId}`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return questionSerializer.normalizeQuestionContent(response.data);
        });
    }

    /**
     * Reads a resource by id
     *
     * @param {string} resourceId
     * @returns {Promise}
     */
    public getResourceById(resourceId: any) {
        const resource = 'resources';
        const url = `${this.namespace}/${resource}/${resourceId}`;
        const headers = http.getTokenHeaders();
        return http.get(url, headers).then((response) => {
            return resourceSerializer.normalizeResourceContent(response.data);
        });
    }

    /**
     * Reads a collection by id
     *
     * @param {string} collectionId
     * @returns {Promise}
     */
    public getCollectionById(collectionId: string) {
        const endpoint = `${this.namespace}/collections/${collectionId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    /**
     * Reads a collection by id
     *
     * @param {string} collectionId
     * @returns {Promise}
     */
     public getAssessmentById(collectionId: string) {
        const endpoint = `${this.namespace}/assessments/${collectionId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    /**
     * Reads a offline activity by id
     * @param {string} activityId
     * @returns {Promise}
     */
    public getActivityById(activityId: string) {
        const endpoint = `${this.namespaceOa}/${activityId}/detail`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    public getCourseById(courseId: string) {
        const endpoint = `${this.namespace}/courses/${courseId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return courseSerializer.normalizeCourseContent(response.data);
        });
    }

    public getLessonId(lessonId: string): Promise<any> {
        const endpoint = `${this.namespace}/lesson/${lessonId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return lessonSerializer.normalizeLesson(response.data);
        });
    }

}

export const contentAPI = ContentAPI.instance;
